import TripBigCard from "../../account/components/TripBigCard";
import TripCardsList from "../../account/components/TripCardsList";
import NewTripLight from "../../account/components/NewTripLight";
import NewTrip from "../../account/components/NewTrip";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchCustomerHistory} from "../../../data/account/actions/account";
import {isEmpty} from "lodash";
import { useTranslation } from "react-i18next";
import TripsFilter from "../../account/components/TripsFilter";
import { getIsFetchingDraft} from "../../../data/booking/selectors/booking";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";
import {Alert} from "../../shared/components/Alert";
import {getUser} from "../../../data/account/selectors/user";
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import cx from "classnames";
import {Link} from "react-router-dom";
import {generate} from "../../../routing/routes";

function filterTrips(tripList, selectedFilters) {
    let newTripList = tripList;

    if (selectedFilters.length > 0) {
        newTripList = newTripList.filter((trip) => {
            return selectedFilters.some((filter) => trip.tags.includes(filter));
        });
    }

    return newTripList;
}

export default function HomeCustomer() {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const {isFetching, isFetchingDrafts, trips} = useSelector(state => state.account.account)
    const draftCount = isEmpty(trips.drafts) ? 0 : trips.drafts.length
    const isFetchingDraft = useSelector(state => getIsFetchingDraft(state.booking))
    const user = useSelector(state => getUser(state))
    const isDeleting = useSelector(state => state.followup.followup.isDeleting)
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [filteredTrips, setFilteredTrips] = useState([]);

    const hikeStatus = [
        { id: "quotation", title: "Demande" },
        { id: "reservation", title: "Réservation" },
        { id: "cancelled", title: "Annulé" },
    ];

    useEffect(()=> {
        dispatch(fetchCustomerHistory())
    }, [])

    let passedLength = !isFetching ? trips.passed.length : 0

    useEffect(() => {
        if(!isFetching) {
            const result = filterTrips(
                trips.passed,
                selectedFilters
            );
            setFilteredTrips(result);
        }
    }, [selectedFilters.length, passedLength]);

    return (
        <>
            <div className={"space-y-16"}>
                {(isFetching || isFetchingDraft) ? 
                <div className={"space-y-16"}>
                    <div className="h-[50vh] overflow-hidden rounded-xl border border-gray-100 shadow-md flex justify-center items-center">
                        <FontAwesomeIcon icon={faCircleNotch} className={"h-10 w-10 text-gray-300 self-center"} spin />
                        <p className="ml-4 text-lg text-gray-800">{t('shared.loading')}...</p>
                    </div>
                </div>
                // <div className="overflow-hidden rounded-xl border border-gray-100 shadow-lg lg:flex lg:flex-row-reverse">
                //     <div className={"lg:w-7/12"}>
                //         <div
                //             className={
                //                 "aspect-w-8 aspect-h-3 w-full rounded-lg bg-cover lg:rounded-none bg-gray-100"
                //             }
                //         ></div>
                //     </div>
                //     <div className={"p-4 pt-0 lg:w-5/12 lg:px-12 lg:py-8"}>
                //         <div className="mt-4 items-start justify-between lg:mt-0">
                //             <div className="w-full lg:mb-4">
                //                 <p className="text-sm text-gray-800 lg:text-xl">
                //                     Chargement...
                //                 </p>
                //             </div>
                //         </div>
                //     </div>
                // </div> 
                : <>
                {isEmpty(user.contact.phoneNumbers) && <Alert alert="warning">
                    <div className="flex items-center">
                        <ExclamationTriangleIcon className="mr-4 h-10 w-10 text-orange-500" />
                        <p>
                            Aucun numéro de téléphone portable n’est enregistré sur votre profil ! <br/>
                            Merci d’en ajouter un dans la rubrique « <Link to={generate('account_informations')} className="underline">Mes informations</Link> ».
                            Il nous permettra de pouvoir vous joindre en cas de besoin durant votre randonnée.
                        </p>
                    </div>
                </Alert>}
                {(!isEmpty(trips.ongoing) || isEmpty(trips.pending)) && <div>
                    <h2 className={"mb-4 text-lg font-semibold"}>{t('booking.upcoming_reservations')}</h2>
                    {isEmpty(trips.ongoing) ? <NewTrip maxDraftCount={draftCount >= 3}/> :<>
                        {trips.ongoing.map((trip, index) => <TripBigCard key={index} trip={trip} />)}
                        {draftCount < 3 && <NewTripLight />}</>}
                </div>}

                {!isEmpty(trips.pending) && <div>
                    <h2 className={"mb-4 text-lg font-semibold"}>{t('booking.pending_requests')}</h2>
                    {trips.pending.map((trip, index) => <TripBigCard key={index} trip={trip} />)}
                    {draftCount < 3 && <NewTripLight />}
                </div>}

                {!isEmpty(trips.refused) && <div>
                    <h2 className={"mb-4 text-lg font-semibold"}>{t('booking.last_requests_refused')}</h2>
                    <TripCardsList trips={trips.refused} editable={false} />
                </div>}

                {!isEmpty(trips.drafts) && <div>
                    <h2 className={"mb-4 text-lg font-semibold"}>
                    {t('booking.status_quotation_drafts')}{' '}
                        {(isDeleting || isFetchingDrafts) && <FontAwesomeIcon icon={faCircleNotch} spin /> }
                    </h2>
                    <TripCardsList
                        trips={trips.drafts}
                        editable={true}
                        isLoading={isDeleting || isFetchingDrafts}
                    />
                </div>}

                {!isEmpty(trips.passed) && <div>
                    <h2 className={"mb-4 text-lg font-semibold"}>
                    {t('booking.previous_reservations_and_requests')}
                    </h2>
                    <div className={"mb-4"}>
                        <TripsFilter setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters} data={hikeStatus} />
                    </div>
                    <TripCardsList trips={filteredTrips} editable={false} />
                </div>}
                </>}
            </div>
        </>
    );
}
